<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>Стоимость судна без НДС за вычетом авансов, тыс. руб.</td>
            <td>Количество платежей</td>
            <td>Размер платежа без НДС, тыс. руб.</td>
            <td>Периодичность платежей</td>
            <td>Стоимость лизинга судна, % годовых</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              v-bind:class="{
                'has-error': $parent.$parent.checkErrorField(
                  'PROJECTS',
                  'LOGIC',
                  'UF_LIZING_SHIP_COST_NO_NDS'
                )
              }"
            >
              <vue-numeric
                currency=""
                separator="space"
                :precision="2"
                v-model="project.UF_LIZING_SHIP_COST_NO_NDS"
                type="text"
                class="i-main-style i-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                @input="
                  $parent.$parent.removeError(
                    'PROJECTS',
                    'LOGIC',
                    'UF_LIZING_SHIP_COST_NO_NDS'
                  )
                "
              />
              <div class="error-text">
                {{
                  $parent.$parent.checkErrorText(
                    "PROJECTS",
                    "LOGIC",
                    "UF_LIZING_SHIP_COST_NO_NDS"
                  )
                }}
              </div>
            </td>
            <td
              v-bind:class="{
                'has-error': $parent.$parent.checkErrorField(
                  'PROJECTS',
                  'LOGIC',
                  'UF_LIZING_SHIP_PAYMENT_COUNT'
                )
              }"
            >
              <input
                type="text"
                class="i-main-style i-co-executor-style"
                v-model="project.UF_LIZING_SHIP_PAYMENT_COUNT"
                :disabled="$parent.$parent.projectDisabled"
                v-on:keypress="isNumber($event)"
                v-on:keyup="
                  $parent.$parent.removeError(
                    'PROJECTS',
                    'LOGIC',
                    'UF_LIZING_SHIP_PAYMENT_COUNT'
                  )
                "
              />
              <div class="error-text">
                {{
                  $parent.$parent.checkErrorText(
                    "PROJECTS",
                    "LOGIC",
                    "UF_LIZING_SHIP_PAYMENT_COUNT"
                  )
                }}
              </div>
            </td>
            <td
              v-bind:class="{
                'has-error': $parent.$parent.checkErrorField(
                  'PROJECTS',
                  'LOGIC',
                  'UF_LIZING_SHIP_PAYMENT_SUM'
                )
              }"
            >
              <vue-numeric
                currency=""
                separator="space"
                :precision="3"
                v-model="project.UF_LIZING_SHIP_PAYMENT_SUM"
                type="text"
                class="i-main-style i-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                @input="
                  $parent.$parent.removeError(
                    'PROJECTS',
                    'LOGIC',
                    'UF_LIZING_SHIP_PAYMENT_SUM'
                  )
                "
              />
              <div class="error-text">
                {{
                  $parent.$parent.checkErrorText(
                    "PROJECTS",
                    "LOGIC",
                    "UF_LIZING_SHIP_PAYMENT_SUM"
                  )
                }}
              </div>
            </td>
            <td
              v-bind:class="{
                'has-error': $parent.$parent.checkErrorField(
                  'PROJECTS',
                  'LOGIC',
                  'UF_LIZING_SHIP_PAYMENT_PERIOD_ID'
                )
              }"
            >
              <select
                v-model="project.UF_LIZING_SHIP_PAYMENT_PERIOD_ID"
                class="sel-dropdown i-main-style i-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                v-on:change="
                  $parent.$parent.removeError(
                    'PROJECTS',
                    'LOGIC',
                    'UF_LIZING_SHIP_PAYMENT_PERIOD_ID'
                  )
                "
              >
                <option value=""></option>
                <option
                  v-for="item in directory.sp_lizing_ship_payment_period"
                  v-bind:value="item.ID"
                  v-bind:key="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
              <div class="error-text">
                {{
                  $parent.$parent.checkErrorText(
                    "PROJECTS",
                    "LOGIC",
                    "UF_LIZING_SHIP_PAYMENT_PERIOD_ID"
                  )
                }}
              </div>
            </td>
            <td
              v-bind:class="{
                'has-error': $parent.$parent.checkErrorField(
                  'PROJECTS',
                  'LOGIC',
                  'UF_LIZING_SHIP_RATE'
                )
              }"
            >
              <!-- значение считает и сохраняет бэк, на форме — только превью -->
              <input
                type="text"
                class="i-main-style i-co-executor-style"
                :value="shipRate"
                disabled
              />
              <div class="error-text">
                {{
                  $parent.$parent.checkErrorText(
                    "PROJECTS",
                    "LOGIC",
                    "UF_LIZING_SHIP_RATE"
                  )
                }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

/** Точность поиска корня по ставке за период (как в LizingShipRateService) */
const RATE_PRECISION = 1.0e-12;

/** Максимум итераций бисекции */
const RATE_MAX_ITERATIONS = 300;

/** Верхняя граница поиска ставки за период */
const RATE_UPPER_BOUND = 10.0;

/** Нижняя граница поиска ставки за период (ставка -100 % и ниже смысла не имеет) */
const RATE_LOWER_BOUND = -0.999999999;

/** Окрестность нуля, в которой невязка считается по предельному значению */
const ZERO_RATE_EPS = 1.0e-10;

export default {
  name: "ship_rate_calc",
  computed: {
    ...mapGetters(["directory", "project"]),

    /**
     * Количество платежей в год по выбранному элементу sp_lizing_ship_payment_period.
     * Повторяет LizingShipRateService::getPaymentsPerYear.
     */
    paymentsPerYear() {
      const id = parseInt(this.project.UF_LIZING_SHIP_PAYMENT_PERIOD_ID, 10);
      if (!(id > 0)) {
        return 0;
      }

      const list = this.directory.sp_lizing_ship_payment_period || [];
      const period = Object.values(list).find(item => item && item.ID == id);
      if (!period) {
        return 0;
      }

      const perYear = parseInt(period.UF_PAYMENT_PER_YEAR, 10);
      if (perYear > 0) {
        return perYear;
      }

      //подстраховка, если свойство справочника не заполнено
      if (period.CODE === "month") {
        return 12;
      }
      if (period.CODE === "quarter") {
        return 4;
      }

      return 0;
    },

    /**
     * Превью годовой ставки. Значение считает и сохраняет бэк (LizingShipRateService::calcRate),
     * здесь тот же расчёт, чтобы поле не показывало 0 до сохранения проекта.
     * Пока данных не хватает — показываем сохранённое значение.
     * Ставка округляется до 6 знаков после запятой (как на бэке).
     */
    shipRate() {
      const pv = Number(this.project.UF_LIZING_SHIP_COST_NO_NDS);
      const nper = parseInt(this.project.UF_LIZING_SHIP_PAYMENT_COUNT, 10);
      const pmt = Number(this.project.UF_LIZING_SHIP_PAYMENT_SUM);
      const perYear = this.paymentsPerYear;

      if (!(pv > 0) || !(nper > 0) || !(pmt > 0) || !(perYear > 0)) {
        return this.project.UF_LIZING_SHIP_RATE;
      }

      const ratePeriod = this.ratePerPeriod(nper, pmt, pv);
      if (ratePeriod === null) {
        return this.project.UF_LIZING_SHIP_RATE;
      }

      return Number((ratePeriod * perYear * 100).toFixed(6));
    }
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["sp_lizing_ship_payment_period"]);
  },
  methods: {
    /**
     * Ставка за период — аналог Excel RATE(nper; -pmt; pv; 0; 0).
     * Уравнение аннуитета монотонно по ставке, корень ищется бисекцией.
     * Отрицательные ставки тоже считаются: если платежей не хватает на возврат
     * стоимости, значение нужно показать, а не подменять нулём — договор отбракует валидация.
     * @returns {number|null} null — корня на (RATE_LOWER_BOUND; RATE_UPPER_BOUND] нет
     */
    ratePerPeriod: function(nper, pmt, pv) {
      //сумма платежей в точности равна стоимости — процентов нет, корень равен нулю
      if (nper * pmt === pv) {
        return 0;
      }

      let lo = RATE_LOWER_BOUND;
      let hi = RATE_UPPER_BOUND;

      if (this.annuityBalance(hi, nper, pmt, pv) < 0) {
        return null;
      }

      for (let i = 0; i < RATE_MAX_ITERATIONS; i++) {
        const mid = (lo + hi) / 2;
        if (this.annuityBalance(mid, nper, pmt, pv) < 0) {
          lo = mid;
        } else {
          hi = mid;
        }
        if (hi - lo < RATE_PRECISION) {
          break;
        }
      }

      return (lo + hi) / 2;
    },

    /**
     * Невязка уравнения аннуитета: pv*(1+r)^n - pmt*(1/r)*((1+r)^n - 1).
     * Монотонно возрастает по r на (-1; +inf), у нуля берётся предел pv - pmt*n.
     */
    annuityBalance: function(rate, nper, pmt, pv) {
      //у нуля 1/r обращается в бесконечность, поэтому берём предел выражения
      if (Math.abs(rate) < ZERO_RATE_EPS) {
        return pv - pmt * nper;
      }

      const factor = Math.pow(1 + rate, nper);

      return pv * factor - pmt * (1 / rate) * (factor - 1);
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
